import React from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export const ServerVarsContextConsumer = Context.Consumer;

export function ServerVarsContextProvider({ children, isDesktop, isMobile, isTablet }) {
    return (
        <Context.Provider
            value={{
                isDesktop,
                isMobile,
                isTablet,
            }}
        >
            {children}
        </Context.Provider>
    );
}

ServerVarsContextProvider.defaultProps = {
    clientConf: {},
};

ServerVarsContextProvider.propTypes = {
    children: PropTypes.node,
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
};
